import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../pages/admin/admin.css";

export default function AdminSidebar() {
  const role = localStorage.getItem("adminRole");
  const tower = localStorage.getItem("adminTower");
  const [open, setOpen] = useState(false);

  const navItems = [
    { to: "/admin/dashboard", label: "👥 Resident Requests" },
    { to: "/admin/notices", label: "📢 Notices" },
    { to: "/admin/maintenance", label: "🔧 Maintenance Issues" },
    { to: "/admin/vendors", label: "🏪 Vendor Directory" },
    { to: "/admin/theatre", label: "🎭 Mini Theatre" },
    { to: "/admin/stats", label: "📊 Dashboard Stats" },
  ];

  if (role === "admin") {
    navItems.push({ to: "/admin/tower-requests", label: "🏢 Tower Admins" });
    navItems.push({ to: "/admin/fms-requests", label: "🏗️ FMS Requests" });
    navItems.push({ to: "/admin/rules", label: "📋 Manage Rules" });
  } else if (tower) {
    // Tower Admin specific items
    navItems.push({ to: "/admin/billing-config", label: "⚙️ Billing Config" });
    navItems.push({ to: "/admin/gate-shifts", label: "🔐 Gate Shift PINs" });
  }

  const identityLabel = role === "admin" ? "Super Admin" : tower ? `${tower} Admin` : "Admin";

  const closeDrawer = () => setOpen(false);

  return (
    <>
      <div className="admin-mobile-bar hide-desktop">
        <button className="admin-hamburger" onClick={() => setOpen(true)} aria-label="Open menu">
          <span></span><span></span><span></span>
        </button>
        <span className="admin-mobile-title">Crown Admin</span>
      </div>

      {open && <div className="admin-drawer-backdrop hide-desktop" onClick={closeDrawer} />}

      <div className={`admin-sidebar ${open ? "open" : ""}`}>
        <button className="admin-drawer-close hide-desktop" onClick={closeDrawer} aria-label="Close menu">✕</button>

        <div className="admin-sidebar-header">
          <div>
            <h2>Crown Admin</h2>
            <div className="admin-identity">{identityLabel}</div>
          </div>
          <button
            className="admin-logout-header"
            onClick={() => {
              localStorage.removeItem("token");
              localStorage.removeItem("adminRole");
              localStorage.removeItem("adminTower");
              window.location.href = "/admin/login";
            }}
            title="Logout"
          >
            🚪
          </button>
        </div>

        <nav className="admin-sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={closeDrawer}
              className={({ isActive }) =>
                isActive ? "admin-nav-btn active" : "admin-nav-btn"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  );
}